import { render, staticRenderFns } from "./tipsCreate.vue?vue&type=template&id=a9e03f4e"
import script from "./tipsCreate.vue?vue&type=script&lang=js"
export * from "./tipsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports